import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ShoppingEntryComponent} from "./shopping-entry/shopping-entry.component";
import {ShoppingComponent} from "./shopping/shopping.component";
import {ProductsComponent} from "./products/products.component";
import {CheckoutComponent} from "./checkout/checkout.component";
import {OrderCompletedComponent} from "./order-completed/order-completed.component";
import {SubscriberComponent} from "./subscriber/subscriber.component";
import {TutorialsComponent} from "../../components/tutorials/tutorials.component";
import {ReversalAuthGuard} from "../../services";
import {HelpComponent} from "../help/help.component";
import {StartedDownloadsComponent} from "../get-started/started-downloads/started-downloads.component";
import {FasterqTerminalComponent} from "../fasterq/fasterq-terminal/fasterq-terminal-component";
import {ChatCustomerComponent} from "../../components/chat/chat-customer/chat-customer.component";
import {EstimatesComponent} from "../../components/estimates/estimates.component";
import {PricesComponent} from "../user/prices/prices.component";
import {CanvaComponent} from "../../components/canva/canva.component";
import {EquippedComponent} from "../user/equipped/equipped.component";
import {DynawebsTextToSpeech} from "../dynabwebs/dynawebs-text-to-speech/dynawebs-text-to-speech";
import {KonenootComponent} from "../user/konenoot/konenoot.component";
import {ChatBot} from "../../components/chat/chat-bot/chat-bot";

export const routes: Routes = [
    {
        path: '', component: ShoppingEntryComponent, data: {state: 'root'},
        children: [
            {path: 'downloads', component: StartedDownloadsComponent, data: {state: 'lazy0', showBack: false}},

            // example: http://localhost:4200/shopping-cart/estimates
            {path: 'estimates', component: EstimatesComponent, data: {state: 'lazy0'}},

            {path: 'tutorials', component: TutorialsComponent, data: {state: 'lazy0'}},
            {path: 'canva', component: CanvaComponent, data: {state: 'lazy0'}},
            {path: 'fasterq/terminal/:term', component: FasterqTerminalComponent, data: {state: ''}},
            {path: 'fasterq/status/:state', component: FasterqTerminalComponent, data: {state: ''}},
            {path: 'list', component: ShoppingComponent, data: {state: 'lazyA'}},
            {path: 'list/:id', component: ShoppingComponent, data: {state: 'lazyB'}},

            // example: http://localhost:4200/shopping-cart/charge/45b31b75657ca86f2579486f9016dff9215a5fb79627b50b8fa0416bdfd730083075260b477784e7:274
            {path: 'charge/:order_id', component: ShoppingComponent, data: {state: 'lazyC'}},

            {path: 'products', component: ProductsComponent, data: {state: 'lazy3'}},
            {path: 'checkout', component: CheckoutComponent, data: {state: 'lazy4'}},
            {path: 'ordercompleted/:order_id', component: OrderCompletedComponent, data: {state: 'lazy5'}},

            // Load Upgrade wizard view only mode:
            // example: http://localhost:4200/shopping-cart/price
            // example: http://localhost:4200/shopping-cart/plan
            // example: http://localhost:4200/shopping-cart/plan/bb5ded195f88e912e1cba866b3f1a6d38c526249cc73e62b668a57edb3db10
            {path: 'price', component: PricesComponent, data: {title: 'Prices'}},

            // For subscriber to upgrade CC info:
            // http://localhost:4200/shopping-cart/subscriber/b847e73268adde07bff0be66b3f1a6d3bb456354fc11bf2f61e24dfba18c6f
            // http://localhost:4200/shopping-cart/subscriber/bb5ded195f88e912e1cba866b3f1a6d38c526249cc73e62b668a57edb3db10


            {path: 'subscriber/:encrypted_id', component: SubscriberComponent, data: {param: ''}},

            {path: 'equipment', canActivate: [ReversalAuthGuard], component: EquippedComponent, data: {title: 'Equipment'}},
            {path: 'equipmentpol', canActivate: [ReversalAuthGuard], component: EquippedComponent, data: {title: 'Equipment'}},
            {path: 'konenoot', canActivate: [ReversalAuthGuard], component: KonenootComponent, data: {title: 'Equipment'}},
            {path: 'texttospeech', canActivate: [ReversalAuthGuard], component: DynawebsTextToSpeech, data: {title: 'TTS'}},
            {path: 'helpdesk/:video_id', canActivate: [ReversalAuthGuard], component: HelpComponent, data: {title: 'Help'}},
            {path: 'helpdesk', canActivate: [ReversalAuthGuard], component: HelpComponent, data: {title: 'Help'}},
            {path: 'chatbot', component: ChatBot, data: {popup: true}},
            {path: 'chat', canActivate: [ReversalAuthGuard], component: ChatCustomerComponent, data: {popup: true}},
            {path: 'chat/:id', canActivate: [ReversalAuthGuard], component: ChatCustomerComponent, data: {popup: true}}
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ShoppingRoutingModule {
}
